export const forcePasswordChangeSelector = (state) => {
    return state.credentials.records.forcePasswordChange;
};

export const credentialsErrorSelector = (state) => {
    return state.credentials.records.error;
};
